import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { heroGuarantees } from '../data/content';
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-12 pt-[15px] sm:pb-20 sm:pt-10" data-id="element-117" data-mp="ei1unjxvvyww">
      <div className="mx-auto max-w-4xl text-center" data-id="element-118" data-mp="9l375k8q6q7o">
        <motion.p initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="text-[11px] font-bold uppercase leading-tight tracking-[0.18em] text-teal sm:text-xs sm:tracking-[0.22em]" data-id="element-119" data-mp="4mi47d239sfj">
          Il curriculum di matematica completo per docenti italiani
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05,
        ease: 'easeOut'
      }} className="mt-3 font-display text-[2.25rem] font-black leading-[1.06] tracking-tight text-navy sm:mt-5 sm:text-[3.4rem] md:text-[4rem]" data-id="element-120" data-mp="ncgiiawhchrm">
          Prepara un Intero Anno di Matematica in Soli{' '}
          <span className="italic text-grape" data-id="element-121" data-mp="3o7c0y05rgtho">5 Minuti</span> di Orologio.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.12,
        ease: 'easeOut'
      }} className="mx-auto mt-3 max-w-2xl text-[15px] leading-snug text-navy/60 sm:mt-6 sm:text-lg sm:leading-relaxed" data-id="element-122" data-mp="39acwgl67hgrf">
          <span className="sm:hidden" data-id="element-123" data-mp="358hleoyh3p0g">
            8 volumi PDF pronti all&apos;uso, dalla 1ª Primaria alla 3ª
            Secondaria. Stampa, apri e insegna.
          </span>
          <span className="hidden sm:inline" data-id="element-124" data-mp="2qhqwboo9n411">
            Matematica Pronta è il sistema completo «chiavi in mano»: 8 volumi
            PDF pronti all&apos;uso carichi di teoria visuale, attività
            operative e verifiche dalla 1ª Primaria alla 3ª Secondaria. Basta
            stampare, aprire e insegnare.
          </span>
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: 'easeOut'
      }} className="mx-auto mt-3 max-w-2xl sm:mt-10" data-id="element-125" data-mp="s335feo1gqy2">
          <img src="https://cdn.magicpatterns.com/uploads/u8fWPSBcfE2GN3GxDEmtoN/hf_20260806_224100_61d90b67-b978-4b08-ab57-51cc30700a18.webp" alt="Il pacchetto Matematica Pronta: 8 volumi stampati, la versione digitale su computer, tablet e telefono e i 5 bonus" className="mx-auto max-h-[34vh] w-full rounded-2xl object-contain sm:max-h-none" data-id="element-126" data-mp="i9vr34bbm0lu" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3,
        ease: 'easeOut'
      }} className="mt-3 sm:mt-8" data-id="element-127" data-mp="x14mxv5tgi7f">
          <CtaButton href="#offerta" data-id="element-128" data-mp="3hqu0m4us9xyj" />
          <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-[11px] font-semibold text-navy/55 sm:mt-5 sm:gap-x-3 sm:gap-y-2 sm:text-xs" data-id="element-129" data-mp="3hpsff7k1zv33">
            {heroGuarantees.map((item, index) => <li key={item} className="flex items-center gap-2 sm:gap-3" data-id="element-130" data-mp="218jx2084ip5h" data-mpi={index}>
                <span data-id="element-131" data-mp="268fybrpfs2hc">
                  <span aria-hidden="true" className="text-teal" data-id="element-132" data-mp="2686aa9nyc5ea">
                    ✓{' '}
                  </span>
                  {item}
                </span>
                {index < heroGuarantees.length - 1 && <span aria-hidden="true" className="text-navy/25" data-id="element-133" data-mp="2kynbbrwoctan">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}